export const imagesPath = 'structem-measure-images/' as const;
export const imagesFullPath = `${imagesPath}fullsize/` as const;
export const imagesThumbPath = `${imagesPath}thumbnails/` as const;

export const autoGenPath = 'src/auto_generated';